<template>
    <div class='container'>
      <h1>智鼎云隐私政策说明</h1>
      <h3>尊敬的用户，您好：</h3>
      <p class="code-line">
          武汉智鼎云网络科技有限公司及智鼎云一站式写字楼管理服务平台（以下简称“智鼎云”或“我们”）注重您个人隐私的保护。有时候我们需要某些信息才能为您提供您请求的服务，本隐私政策声明解释了这些情况下的数据收集和使用情况。本隐私政策声明适用于武汉智鼎云网络科技有限公司旗下的智鼎云一站式写字楼管理服务平台的各个客户端（包括：<code>智鼎云APP</code>、<code>智鼎云网站</code>、<code>智鼎云公众平台APP</code>、及<code>智鼎云管理平台</code>等）及其提供的所有相关产品和服务。
      </p>
      <h2>一、我们如何收集和使用您的个人信息</h2>
      <p class="code-line">
         个人信息是指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。<br>
        个人敏感信息包括身份证号码、个人生物识别信息、银行账号、财产信息、行踪轨迹、交易信息、14岁以下（含）儿童的个人信息等。<br>
        我们仅会出于本声明所述的以下业务目的，收集和使用您的个人信息：<br>
        <ol>
            <li>
                登录和注册<br>
                当您登录<code>智鼎云APP</code>之前，需要通过手机号注册，我们会记录下您的手机号码，以便于更好地为您提供服务。
            </li>
             <li>
                实名登记<br>
                <code>智鼎云APP</code>是写字楼租赁管理平台，需要您提供真实有效的身份信息，包括姓名和身份证号码，我们才能够保障线上办公租赁交易的安全性，这也是国家政策、法律法规的要求。我们不会对外提供您的个人身份信息。
            </li>
            <li>
                预约看房<br>
                位置信息：在使用<code>智鼎云APP</code>的时候我们可能会获取到您的位置信息，为您提供相应的看房服务。<br>
                网络信息：手机联网模式、是否连接网络，防止您因为流量不足而使用APP产生流量费用。<br>
                拍照信息：当您使用<code>智鼎云APP</code>进行扫码时，我们需要获取您相机的拍照权限，以便提供报事报修反馈。<br>
            </li>
            <li>
                实名登记<br>
                智鼎云APP是写字楼租赁管理平台，需要您提供真实有效的身份信息，包括姓名和身份证号码，我们才能够保障线上办公租赁交易的安全性，这也是国家政策、法律法规的要求。我们不会对外提供您的个人身份信息。
            </li>
        </ol>
      </p>
       <div class="code-line">
        <h3>以上信息是智鼎云提供服务所必须的个人基础信息。若您不提供，您将无法正常使用我们的服务。</h3>
       </div>
        <h2>二、用户个性化推荐</h2>
        <p class="code-line">
            我们可能根据您的个人信息向您推送您可能感兴趣的房源，包括但不限于在通知栏展示活动、评论等信息，您可以在手机设置关闭推送通知。
        </p>
        <h2>三、您的数据主体权利</h2>
        <p class="code-line">
            为使您正在使用智鼎云的产品和服务期间更加便捷地访问、更正和删除您的个人信息，同时保障您有权撤回对个人信息的使用许可，我们在产品设计中为您提供了相应的操作设置，您可以在相应的模块做出操作。
        </p>
        <h2>四、您个人信息的安全</h2>
        <p class="code-line">
            严格保护您的个人信息的安全。我们使用各种安全技术和程序来保护您的个人信息不被未经授权的访问、使用或泄漏。如果您对我们的隐私保护有任何置疑，请 email 至 <a href="javascript:;">@zhidingcloud.com。</a>
        </p>


      <h2>五、数据存储地点及期限</h2>
      <p class="code-line">
         个人信息是指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。<br>
        个人敏感信息包括身份证号码、个人生物识别信息、银行账号、财产信息、行踪轨迹、交易信息、14岁以下（含）儿童的个人信息等。<br>
        我们仅会出于本声明所述的以下业务目的，收集和使用您的个人信息：<br>
        <ol>
            <li>
                数据存储地点<br>
                我们在本服务项下收集和产生的个人信息，将存储在中华人民共和国内。
            </li>
             <li>
                数据存储期限<br>
                我们仅在实现本声明目的所必需的时间内保留您的个人信息，并在超出下述保留时间后删除或匿名化处理您的个人信息，但法律法规另有要求的除外。在智鼎云业务中，您的个人数据具体留存时间如下：
                <ol>
                    <li>
                       当您电话联系客服要求注销账号,我们不再保存您的个人信息。客服电话<strong>4000989222</strong>。
                    </li>
                    <li>
                       当我们的产品或服务发生停止运营的情形时，我们将以推送通知、公告等形式通知您，并在合理的期限内删除您的个人信息或进行匿名化处理。                        
                    </li>
                </ol>
            </li>
        </ol>
      </p>
      <h2>六、本声明如何更新</h2>
      <p class="code-line">
                <ol>
                    <li>
                      通过各大应用商店进行更新
                    </li>
                    <li>
                       通过智鼎云网站（<a href="https://www.zhidingcloud.com">https://www.zhidingcloud.com</a>）进行更新。
                    </li>
                </ol>           
      </p>
      <h2>七、关于免责</h2>
      <p class="code-line">
           当下列相关事宜的发生，智鼎云不承担任何法律责任：
                <ol>
                    <li>
                      智鼎云会在法律要求或符合智鼎云的相关服务条款、软件许可使用协议约定的情况下透露您的个人信息，或者有充分理由相信必须这样做才能：
                        <ol>
                            <li>
                            满足法律的明文规定，或者符合智鼎云本应用适用的法律程序；
                            </li>
                            <li>
                            符合智鼎云相关服务条款、软件许可使用协议的约定；
                            </li>
                            <li>
                            保护智鼎云的权利或财产，以及在紧急情况下保护智鼎云的员工、智鼎云产品或服务的用户或大众的个人安全。
                            </li>
                        </ol>
                    </li>
                    <li>
                       智鼎云根据法律规定或相关政府的要求提供您的个人信息;
                    </li>
                    <li>
                       非因智鼎云原因导致的个人信息的泄漏；
                    </li>
                     <li>
                       任何第三方根据智鼎云各服务条款及声明中所列明的情况使用您的个人信息由此所产生的纠纷；
                    </li>

                    <li>
                      任何由于黑客攻击、电脑病毒侵入或政府管制而造成的暂时性服务停止；
                    </li>
                    <li>
                      因不可抗力导致的任何后果；
                    </li>
                     <li>
                      智鼎云在各服务条款及声明中列明的免责情形。
                    </li>                    
                </ol>           
      </p>
      <h2>八、隐私声明的修订：</h2>
      <p class="code-line">
        根据需要，将随时修改本隐私声明。我们建议用户定期上网查看最新的隐私政策与使用条款规定。未来任何条款如有更新，我们将不主动提醒用户，亦不会回溯应用在之前所发生的情形，同时不会改变我们对于之前所收集的资料之处理方式。       
      </p>
    </div>
</template>

<script>
export default {
    name:'explain',
    mounted(){
        let dom = document.documentElement || document.body;
        dom.scrollTop = 0;
    }
}
</script>

<style lang="less" scoped>
.container{
  padding:50px;
  max-width:1200px;
  margin:auto;
  h2{
      font-size:23px
  }
  code{
    color: #c7254e;
    background-color: #f9f2f4;
    border-radius: 4px;
  }
  a {
    cursor: pointer;
    color: #35D7BB;
    text-decoration: none;
    }
  .code-line{
    margin-bottom: 30px;
    padding-top: 10px;
  }
  .code-line{
      padding-top:10px;
      line-height:1.8;
      ol{
         margin-bottom: 20px;
         margin-top: 20px;
         padding-left: 60px;
      }
  }
}
</style>